export default __webpack_public_path__ + "static/pink-fb66ccfd49cf5b1234ff7166592489c0.png";